export default __webpack_public_path__ + "static/media/cholet7.8f39913d.jpg";